// Read the response body defensively rather than via axios.isAxiosError: the
// bundler can resolve a second axios copy, making isAxiosError return false
// for a genuine axios error.
function errorResponse(
  error: unknown
): { status?: unknown; data?: unknown } | undefined {
  if (typeof error !== 'object' || error === null || !('response' in error)) {
    return undefined
  }
  const { response } = error
  return typeof response === 'object' && response !== null
    ? response
    : undefined
}

/** HTTP status of a failed request, if the error carries a response. */
export function extractErrorStatus(error: unknown): number | undefined {
  const status = errorResponse(error)?.status
  return typeof status === 'number' ? status : undefined
}

export function extractErrorMessage(
  error: unknown,
  fallback = 'Upload failed. Please try again.'
): string {
  const data = errorResponse(error)?.data
  const responseMessage =
    typeof data === 'object' && data !== null && 'message' in data
      ? data.message
      : undefined
  if (Array.isArray(responseMessage)) return responseMessage.join(', ')
  if (typeof responseMessage === 'string') return responseMessage
  return fallback
}
